import axios from 'axios';

import { headers, salesServiceUrl } from '../../config';
import queryString from '../../utils/queryString';
// import { eventBus } from '../../utils/eventBus';

// let clientGet = axios.get;

// const get = function(url, config) {
//     return new Promise((resolve, reject) => {
//         clientGet(url, config)
//             .then(response => {
//                 resolve(response);
//             })
//             .catch(error => {
//                 eventBus.$emit("error", "I am an error message");
//                 reject(error);
//             })
//         });
// }
export function createCustomerActivity({form, dpk}) {
    return axios.post(`${salesServiceUrl}/customer-activities`, form, { headers: {...headers(), Dpk: dpk} });
}

export function updateCustomerActivity({id, form}) {
    return axios.put(`${salesServiceUrl}/customer-activities/${id}`, form, { headers: headers()});
}

export function getCustomerActivities(payload) {
    let query = queryString(payload);
    return axios.get(`${salesServiceUrl}/customer-activities?${query}`, { headers: headers() })
}

export function createCustomerActivityComment(customerActivityId, form, dpk) {
    return axios.post(`${salesServiceUrl}/customer-activities/${customerActivityId}/comments`, form, { headers: {...headers(), Dpk: dpk} });
}

export function getCustomerActivityComments(customerActivityId) {
    return axios.get(`${salesServiceUrl}/customer-activities/${customerActivityId}/comments`, { headers: headers() })
}

export function closeCustomerActivity(customerActivityId) {
    return axios.put(`${salesServiceUrl}/customer-activities/${customerActivityId}/close`, {}, { headers: headers() })
}

export function assignTo(customerActivityId, payload) {
    return axios.put(`${salesServiceUrl}/customer-activities/${customerActivityId}/assign`, { assignee_id: payload.assignee_id }, { headers: headers() })
}

export function getCustomerActivityTypes() {
    return axios.get(`${salesServiceUrl}/customer-activity-types`, { headers: headers() })
}

export function getCustomerActivityTouchPoints() {
    return axios.get(`${salesServiceUrl}/customer-activity-touch-points`, { headers: headers() })
}